package components


import JQid
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.html.style
import kotlinx.html.*
import kotlinx.html.js.header
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import pages.home.homePage
import pages.projects.projectsPage


inline fun TagConsumer<HTMLElement>.myHeader() {

    header("header") {



    // scss{ ".header{}" }

nav {
        img(classes = "titleLogo") {
            src = "./willcodeforfood.png"
           style = "border: 1px solid rgba(1,1,1,0.15); transform-origin: right; border-right: 1.7px solid #f3f3f9; height: 100%; padding: 0; vertical-align: baseline; max-height: 69px; object-fit: cover; margin: 0 3px 0 49px; float: left; transform: scaleX(1.5);"
        }

        input(classes = "hamMenuCkb hamb") {
                type = InputType.checkBox
                id = "hamMenuCkb"
            }
        label("hamMenuIconLbl hamb") {
            htmlFor = "hamMenuCkb"
            span("navicon") {
                }
        }
        ul("menu") {


            li {

                a(href = "${window.location.origin}#") { +"About Me" }
               onClickFunction = { homePage() }
            }
            li {
                a(href = "${window.location.origin}#Resume") { +"Resume" }
               //onClickFunction = { somePage() }
            }
            li {
                a(href = "${window.location.origin}#Projects") { +"Projects"
                onClickFunction = { projectsPage() }
                }

            }
            li {
                a(href = "${window.location.origin}#Misc") { +"Misc" }
               //onClickFunction = { somePage() }
            }
        }

        style {
            +"""
             @import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
             @import url('https://fonts.googleapis.com/css2?family=Rubik&display=swap');
             @import url('https://fonts.googleapis.com/css2?family=Merriweather&display=swap');
             .dark .header {
                 background-color: rgba(66,66,75,0.3);
                 box-shadow: 1px 1px 5px 2px rgba(11,5,15,0.7), 3px 4px 5px 10px rgba(11,5,15,0.15);
                 border: 1px solid rgba(133,133,133,0.15);
            }
             .dark .header ul {
                 background-color: rgba(70,70,85,0.15) 
            }
             .header {
                 margin-left: 5px;
                 padding-top: 4px;
                 padding-bottom: 4px;
                 background-color: #adbed9;
                 box-shadow: -1px 2px 2px 3px rgba(51,53,51,0.25), -2px 4px 3px 4px rgba(51,53,51,0.09), -3px 5px 4px 7px rgba(77,77,77,0.05);
                 position: fixed;
                 width: 100%;
                 z-index: 3;
            }
             .header ul {
                 background-color: #adbed9;
                 margin: 0;
                 padding: 0;
                 list-style: none;
                 overflow: hidden;
            }
            .dark .header ul li {
                 border-top: 1px solid rgba(19, 19, 5, 0.65);
                 border-radius: 2px;
            }
             .header ul li {
                 border-top: 1px solid rgba(202, 203, 99, 0.3);
                 border-radius: 2px;
            }
             .header li a {
                 color: #140521;
                 display: block;
                 padding: 20px 20px;
                 border-right: 1.7px solid #f3f3f9;
                 text-decoration: none;
                 text-shadow: 0 0 1px #140521;
                 font-size: 125%;
            }
             .dark .header li a:hover {
                 background-color: rgba(11,10,10, 0.05);
                 box-shadow: inset 2px 2px 1px 2px rgba(8,8,10,0.27), inset 2px 2px 2px 4px rgba(0,0,0,0.12), inset 3px 3px 3px 9px rgba(0,0,0,0.08);
            }
             .header li a:hover, .header .hamMenuCkb:hover {
                 background-color: #f2eff2;
                 box-shadow: inset 2px 1px 1px 2px rgba(100,101,109,0.63), inset 3px 2px 2px 5px rgba(99,99,99,0.16), inset 4px 3px 4px 12px rgba(66,66,66,0.07);
                 text-shadow: 1px 1px 2px #140521;
                 transform: translate(1px, 1px);
            }
             .dark .header li a::before {
                 background-color: lightgray;
            }
             .header li a::before {
                 content: '';
                 position: absolute;
                 width: 70%;
                 height: 0.22em;
                 border-radius: 6px;
                 background-color: rgba(1,1,1,0.7);
                 bottom: 20%;
                 left: 2.5%;
                 right: 57%;
                 transform-origin: right;
                 transform: scaleX(0);
                 transition: transform 1s ease-out;
            }
             .header li a:hover::before {
                 transform-origin: left;
                 transform: scaleX(1);
            }
            
             .header .titleLogo {
                 color: unset;
            }

            /* menu */
             .header .menu {
                 font-family: 'Lato', sans-serif;
                 clear: both;
                 max-height: 0;
                 transition: max-height .3s ease-out;
            }
            /* menu icon */
             .header .hamMenuIconLbl {
                 cursor: pointer;
                 display: inline-block;
                 float: left;
                 padding: 26px 16px;
                 padding-top: 28px;
                 position: relative;
                 user-select: none;
            }
             .dark .header .hamMenuIconLbl .navicon, .dark .header .hamMenuIconLbl .navicon:before, .dark .header .hamMenuIconLbl .navicon:after {
                 background: #ddd;
            }
             .header .hamMenuIconLbl .navicon {
                 background: #222;
                 display: block;
                 height: 4px;
                 position: relative;
                 transition: background .3s ease-out;
                 width: 44px;
            }
             .header .hamMenuIconLbl .navicon:before, .header .hamMenuIconLbl .navicon:after {
                 background: #333;
                 content: '';
                 display: block;
                 height: 100%;
                 position: absolute;
                 transition: all .3s ease-out;
                 width: 100%;
            }
             .header .hamMenuIconLbl .navicon:before {
                 top: 2vh;
            }
             .header .hamMenuIconLbl .navicon:after {
                 top: -2vh;
            }
            /* menu btn */
             .header .hamMenuCkb {
                 display: none;
            }
             .header .hamMenuCkb:checked ~ .menu {
                 max-height: 285px;
            }
             .header .hamMenuCkb:checked ~ .hamMenuIconLbl .navicon {
                transition: transform .3s ease-in-out;
                 background: transparent;
            }
             .header .hamMenuCkb:checked ~ .hamMenuIconLbl .navicon:before {
                 transform: rotate(-45deg);
            }
             .header .hamMenuCkb:checked ~ .hamMenuIconLbl .navicon:after {
                 transform: rotate(45deg);
            }
             .header .hamMenuCkb:checked ~ .hamMenuIconLbl:not(.steps) .navicon:before, .header .hamMenuCkb:checked ~ .hamMenuIconLbl:not(.steps) .navicon:after {
                 top: 0;
            }
            /* 48em = 768px */
             .header .menu li {
                 position: relative;
            }
             @media screen and (min-width: 765px) {
                 .header li a::before {
                     left: 19%;
                     right: 21%;
                     transition: transform .3s ease-out;
                }
                 .header li {
                     float: left;
                }
                 .header li a {
                     padding: 20px 30px;
                }
                 .header .menu {
                     clear: none;
                     float: left;
                     max-height: none;
                }
                 .header .hamMenuIconLbl {
                     display: none;
                }
            }
             
        """.trimIndent()

        }
            //apply { this.asDynamic().innerHTML }

        }

        darkModeSwitch()



    }
   visitorCounterBadge();


}

inline fun FlowContent.darkModeSwitch() {
    div("ckbDarkMode") {

onClickFunction = { JQid("inpCkbDarkMode").asDynamic().click()   }
        checkBoxInput {
            id = "inpCkbDarkMode"
            type = InputType.checkBox
            style = "visibility: hidden; pointer-events: none;"

            onChangeFunction = { ev ->
                val targ = ev.target

                if (targ.asDynamic().checked is Boolean) {
                    val checkStatus = targ.asDynamic().checked as Boolean
                    if (checkStatus) {
                        document.body!!.classList.add("dark")
                        targ.asDynamic().nextElementSibling.style.left = "38px"
                        targ.asDynamic().parentElement.style.backgroundColor = "#cacacc"


                    } else {
                        document.body!!.classList.remove("dark")
                        targ.asDynamic().nextElementSibling.style.left = "-9px"
                        targ.asDynamic().parentElement.style.backgroundColor = "#aaa"
                    }

                }
                //document.body!!.classList.add("dark")

            }

        }
        label("darkmodelabel") {

            style = """
                   display: block;
                   
                    width:  32px;
                    height: 32px;
                    border-radius: 50%;
                    transition:
                        all .5s ease,
                        border .1s; 
                    cursor: pointer; 
                    position: absolute;
                    top: -7px;
                    left: -9px;
                    background: #333333;
            """.trimIndent()
            htmlFor = "inpCkbDarkMode"
            onClickFunction = { JQid("inpCkbDarkMode").asDynamic().click()   }

        }
        style {
            +"""
               html, body {
               background-color: #eaeaed;
  transition: background-color 500ms;
}

.dark .bio button {
   background-color: #253030;
   border: 3px solid rgba(99, 91, 99, 0.5);

}

.dark {
  background: #333;
}

.darkmodelabel {
  border: 2px solid #fff;
}

.ckbDarkMode::before {
  content: 'dark mode:';
  position: absolute;
  top: -18px;
  left: -2px;
  font-size: .74rem;
  font-weight: bold;
  font-family: monospace;
  white-space: nowrap;
  opacity: .85;
  color: #ccc;
}

body.dark, body.dark * { color: #ccc; }
.dark header,
.dark header ul,
.dark header ul a {
  background: rgba(50, 50, 50, .2);
  color: #ccc;
}

.header, .header * {
   z-index: 999;
}

.dark .header li a {
  border-right: 1.7px solid #000;
}

.header input[type=checkbox] {
  visibility: hidden;
}

.header .ckbDarkMode {
  width: 63px;
  height: 18px;
  background: #aaa;
  border: 2px solid #88a;
  position: absolute;
  right: 10px;
  top: 4px;
  border-radius: 7px;
  float: right;
  margin-top: 1.55em;
  margin-right: 4vw;
  transition: background-color 500ms;
  cursor: pointer;
  border: 1px solid #222;
  box-shadow: inset 1px 1px 1px 2px rgba(22, 22, 22, .18);
}

@media screen and (min-width: 785px) {
  .ckbDarkMode {
    transform: scale(1.28);
  }
}

@media screen and (max-width: 785px) {
  .ckbDarkMode {
    transform: scale(1.05, 1.25);
  }
}

@media screen and (max-width: 399px) {
  .header .ckbDarkMode {
    transform: scale(.96, 1.25) translate(2.5vw);
  }

  .header nav .hamb {
    padding-left: 16px;
    padding-right: 18px;
    transform: translate(-8px) scale(.96, 1.05);
  }

  .header nav .titleLogo {
      border-right: 1.7px solid #f3f3f9;
  }

  .header nav,
  .header nav * {
    transform: translate(-2vw);
  }
}

@media screen and (max-width: 341px) {
  .header nav {
    transform: scaleX(.92) translate(-30px);
  }

  .header {
    transform: translate(-5px);
  }

  .header nav .titleLogo {
    transform: scale(.84, 1.04);
    padding-left: 2px;
    padding-right: 2px;
    margin-right: .3vw;
  }

  .header nav .hamb {
    padding-left: 14px;
    padding-right: 15px;
    transform: translate(-8px) scale(.97, 1.05);
  }

  .header .ckbDarkMode {
    transform: scale(.93, 1.27) translate(3.5vw);
  }
}
                """
        }
    }
}

